import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet";

import {
    Grid,
    Card as MuiCard,
    Divider as MuiDivider,
    Typography as MuiTypography, CardContent, Box,
} from "@material-ui/core";

import { Tab } from "../../../components"


import {useAuth} from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";


import CredibilityTab from "./components/Credibility.tab";
import ComprehensiveTab from "./components/Comprehensive.tab";
import AgeTab from "./components/Age.tab";
import {spacing} from "@material-ui/system";

const Typography = styled(MuiTypography)(spacing);

const ColouredTypography = styled(Typography)`
  color: ${(props) => props.custom_color ? props.custom_color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`

const DefaultColouredTypography = styled(Typography)`
  color: ${(props) => props.custom_color ? props.custom_color : props.theme.palette.tertiary.main};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-family: "Lemon/Milk";
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`

const TabsComponents = [
    {
        title: "Comprehensiveness",
        tag: <ComprehensiveTab key={0}/>,
        footer: "Section 3.1. Alignment Analysis",
        footer_link: "/partner/enhancement/content"
    },
    // {
    //     title: "Credibility",
    //     tag: <CredibilityTab/>,
    // },
    // {
    //     title: "Appropriateness",
    //     tag: <AgeTab/>,
    //     footer: "Section 3.1. Appropriateness",
    //     footer_link: "/partner/enhancement/content",
    // },
]

function Assessment() {

    const { authUser } = useAuth();

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];

    const [loading, setLoading] = useState(false);
    const [modulesInfo, setModulesInfo] = useState([]);
    const [currentTab, setCurrentTab] = useState(0);

    const handleChange = (value) => {
        setCurrentTab(value)
    };

    useEffect( () => {

    }, []);

    return (
        <React.Fragment>
            <Helmet title="Assessment Content"/>
            <Box mx={"3vw"}>
                <Box mb={5}>
                    <DefaultColouredTypography variant="h2">
                        Section 2: Assessment
                    </DefaultColouredTypography>
                    <ColouredTypography variant={"body1"} size={"16px"}>
                        Understanding the DQ Impact Rating of the Program
                    </ColouredTypography>
                </Box>
                <Box mb={7}>
                    <ColouredTypography variant="h6" custom_color={"#25b7db"} size={"16px"} weight={"bold"}>
                        {`2.1 Content Assessment: `}
                        <ColouredTypography variant="body1" fontWeight="fontWeightRegular" component={"span"} size={"16px"}>
                            What is the quality of the Program's learning content?
                        </ColouredTypography>
                    </ColouredTypography>
                </Box>
                <Tab
                    titles={TabsComponents.map((component) => component.title)}
                    onChange={handleChange}
                >
                {TabsComponents.map((component) => component.tag)}
                </Tab>
            </Box>
            <Box mx={"3vw"} my={"2vw"}>
                <ColouredTypography variant={"body1"} size={"16px"} align={"center"}>
                    {`Learn more the detailed results of the analysis, please check `}
                    <a href={TabsComponents[currentTab].footer_link} style={{color: "#25b7db"}}>
                        {TabsComponents[currentTab].footer}.
                    </a>
                </ColouredTypography>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </React.Fragment>
    );
}

export default Assessment;
